import * as React from 'react'
import { SVGProps } from 'react'

const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg height={357} viewBox="0 0 357 357" width={357} {...props}>
    <path d="M25.5 357h102V0h-102zm204-357v357h102V0z" />
  </svg>
)

export default SvgPause
